/* eslint-disable */
import { observable, action } from 'mobx'
import axios from 'axios'

import user from '../utils/user'

import Auth from './Auth'

import config from '../config'

class User {
  @observable all = []
  @observable search = []
  @observable
  me = {
    pending: true
  }

  @observable groups = []

  @action
  getUser = userId => {
    if (!userId) {
      userId = Auth.token.userId
    }

    if (userId === Auth.token.userId) {
      this.me = {
        pending: true
      }
    }

    return axios({
      method: 'get',
      url: `${config.api_uri}/user/${userId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        const _userIndex = this.all.findIndex(u => u.id === userId)

        this.all.replace(
          _userIndex > -1
            ? [
                ...this.all.slice(0, _userIndex),
                {
                  ...res.data.data,
                  permissions: user.parsePermList(res.data.data)
                },
                ...this.all.slice(_userIndex + 1)
              ]
            : [...this.all.slice(), res.data.data]
        )

        console.log(res.data.data, user.parsePermList(res.data.data))

        if (userId === Auth.token.userId) {
          return (this.me = {
            pending: false,
            ...res.data.data,
            permissions: user.parsePermList(res.data.data)
          })
        } else {
          return this.all
        }
      })
      .catch(e => {
        console.warn(e)
        return Promise.reject()
      })
  }

  @action
  getAllUsers = () => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/search/?type=user&q=*&page=1&limit=999`,
      query: {
        type: 'user',
        q: '*'
      },
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.all.replace([
          ...res.data.hits.hits.reduce(
            (arr, u) => [...arr, ...(this.me.id !== u._id ? [u._source] : [])],
            []
          ),
          this.me
        ])

        return this.all
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  searchUsers = query => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/search/?type=user&q=${query}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        const users = res.data.hits.hits.reduce(
          (arr, u) => [...arr, u._source],
          []
        )

        this.search.replace([...users])

        this.all.replace([
          ...[...this.all.slice(), ...users].reduce(
            (arr, u) => [
              ...arr,
              ...(arr.find(_u => _u.id === u.id) ? [] : [u])
            ],
            []
          )
        ])

        return this.search
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  patchUser = (userId, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/user/${userId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        if (userId === Auth.token.userId) {
          return (this.me = {
            ...this.me,
            ...(field === 'group'
              ? (function(_self) {
                  const _groups = _self.groups
                    .slice()
                    .filter(g => value.includes(g.id))
                  const _permissions = user.parsePermList({ groups: _groups })

                  return {
                    groups: _groups,
                    permissions: _permissions
                  }
                })(this)
              : { [field]: value })
          })
        }

        const _userIndex = this.all.findIndex(u => u.id === userId)
        if (_userIndex < 0) {
          return
        }

        return this.all.replace([
          ...this.all.slice().slice(0, _userIndex),
          {
            ...(field === 'group'
              ? (() => {
                  const _groups = this.groups
                    .slice()
                    .filter(g => value.includes(g.id))
                  const _permissions = user.parsePermList({ groups: _groups })

                  return {
                    ...this.all.slice()[_userIndex],
                    groups: _groups,
                    permissions: _permissions
                  }
                })()
              : {
                  ...this.all.slice()[_userIndex],
                  [field]: value
                })
          },
          ...this.all.slice().slice(_userIndex + 1)
        ])
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getGroup = groupId => {
    if (!groupId) {
      return Promise.resolve(new Error('groupId is required'))
    }

    return axios({
      method: 'get',
      url: `${config.api_uri}/user/group/${groupId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        const _groupIndex = this.all.find(g => g.id === groupId)
        return this.groups.replace(
          _groupIndex > -1
            ? [
                ...this.all.slice(0, _groupIndex),
                { ...res.data.data },
                ...this.all.slice(_groupIndex + 1)
              ]
            : [...this.all.slice(), res.data.data]
        )
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getAllGroups = () => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/user/group`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        return this.groups.replace([...res.data.data])
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  patchGroup = (groupId, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/user/group/${groupId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        const _index = this.groups.slice().findIndex(g => g.id === groupId)
        return this.groups.replace([
          ...this.groups.slice().slice(0, _index),
          {
            ...this.groups.slice()[_index],
            permissions: {
              ...value
            }
          },
          ...this.groups.slice().slice(_index + 1)
        ])
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  postGroup = data => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/user/group`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data
    })
      .then(res => {
        this.groups.replace([...this.groups.slice(), data])

        return this.groups
      })
      .catch(e => {
        console.warn(e)
      })
  }
}

export default new User()



// WEBPACK FOOTER //
// ./src/stores/User.js